export default "__VITE_ASSET__BDItDsgC__"